import DomainModel from './DomainModel'

class MrdDocument extends DomainModel {
  case: any
  constructor(
    private id: string,
    private caseId: string,
    private investigatorId: string,
    private hospitalId: string,
    private expenseDetails: any[],
    private claimNumber: string,
    private investigatorEmpId: string,
    private investigatorName: string,
    private hospitalName: string,
    private hospitalState: string,
    private hospitalDistrict: string,
    private claimAnalyst: string,
    private insuranceCompany: string,
    private createdAt: any,
    private updatedAt: any



  ) {
    super()
  }

  getId = () => this.id
  getCaseId = () => this.caseId
  getInvestigatorId = () => this.investigatorId
  getHospitalId = () => this.hospitalId
  getExpenseDetials = () => this.expenseDetails
  getClaimNumber = () => this.claimNumber
  getInvestigatorEmpId = () => this.investigatorEmpId
  getInvestigatorName = () => this.investigatorName
  getClaimAnalyst = () => this.claimAnalyst
  getHospitalName = () => this.hospitalName
  getHospitalDistrict = () => this.hospitalState
  getHospitalState = () => this.hospitalDistrict
  getInsuranceCompnay = () => this.insuranceCompany
  getCreatedAt = () => this.createdAt
  getUpdatedAt = () => this.updatedAt

}

export default MrdDocument
